/**
 * StockoutAlertWidget
 * Widget compacto de alerta de ruptura (dashboard ERP).
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ShieldAlert, ArrowRight, AlertTriangle } from 'lucide-react'
import './StockoutAlertWidget.css'

function StockoutAlertWidget({ stockAlerts }) {
  const navigate = useNavigate()
  const totalCount = stockAlerts?.totalCount || 0
  const items = stockAlerts?.items || []

  return (
    <div className="stockout-alert-widget">
      <div className="stockout-alert-widget-header">
        <h3 className="stockout-alert-widget-title">
          <ShieldAlert size={16} className="stockout-alert-widget-icon" />
          Alerta de Ruptura
        </h3>
        <button
          type="button"
          onClick={() => navigate('/erp/purchases/intelligence')}
          className="stockout-alert-widget-nav"
          title="Abrir Compra Inteligente"
        >
          <ArrowRight size={18} />
        </button>
      </div>

      <div className="stockout-alert-widget-content">
        <div className="stockout-alert-widget-summary">
          <div className="stockout-alert-widget-summary-icon">{totalCount}</div>
          <p className="stockout-alert-widget-summary-text">Itens abaixo do mínimo</p>
          <AlertTriangle size={16} className="stockout-alert-widget-summary-warning" />
        </div>

        <div className="stockout-alert-widget-list">
          {items.slice(0, 2).map((item) => (
            <div key={item.id} className="stockout-alert-widget-item">
              <span className="stockout-alert-widget-item-name">{item.name}</span>
              <span className="stockout-alert-widget-item-stock">
                {item.stock} / {item.minimum} un
              </span>
            </div>
          ))}
        </div>
      </div>

      {totalCount > 2 && (
        <button
          type="button"
          className="stockout-alert-widget-link"
          onClick={() => navigate('/erp/purchases/intelligence')}
        >
          Ver todos ({totalCount})
        </button>
      )}

      <button
        type="button"
        onClick={() => navigate('/erp/purchases/intelligence')}
        className="stockout-alert-widget-btn"
      >
        Abrir Compra Inteligente
      </button>
    </div>
  )
}

export default StockoutAlertWidget
